import "core-js/modules/es.array.reverse.js";
import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6, default as _styled7, default as _styled8 } from "styled-components";
const _excluded = ["btnText"];
var _dec, _dec2, _dec3, _dec4, _class, _class2, _descriptor;
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/web.dom-collections.iterator.js";
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { action, computed, makeObservable, observable, runInAction, toJS } from "mobx";
import { observer } from "mobx-react";
import { createRef, Component } from "react";
import Sortable from "react-anything-sortable";
import { Trans, useTranslation, withTranslation } from "react-i18next";
import styled, { withTheme } from "styled-components";
import combine from "terriajs-cesium/Source/Core/combine";
import createGuid from "terriajs-cesium/Source/Core/createGuid";
import dataStoriesImg from "../../../wwwroot/images/data-stories-getting-started.jpg";
import { Category, StoryAction } from "../../Core/AnalyticEvents/analyticEvents";
import triggerResize from "../../Core/triggerResize";
import Box from "../../Styled/Box";
import Button, { RawButton } from "../../Styled/Button";
import Icon, { StyledIcon } from "../../Styled/Icon";
import Spacing from "../../Styled/Spacing";
import Text, { TextSpan } from "../../Styled/Text";
import { withViewState } from "../Context";
import measureElement from "../HOCs/measureElement";
import VideoGuide from "../Map/Panels/HelpPanel/VideoGuide";
import { getShareData } from "../Map/Panels/SharePanel/BuildShareLink";
import SharePanel from "../Map/Panels/SharePanel/SharePanel";
import Story from "./Story";
import StoryEditor from "./StoryEditor";
import Styles from "./story-builder.scss";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const STORY_VIDEO = "storyVideo";
let StoryBuilder = (_dec = action.bound, _dec2 = action.bound, _dec3 = action.bound, _dec4 = action.bound, observer(_class = (_class2 = class StoryBuilder extends Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "storiesWrapperRef", /*#__PURE__*/createRef());
    _defineProperty(this, "refToMeasure", void 0);
    _defineProperty(this, "clearRecaptureSuccessTimeout", void 0);
    _defineProperty(this, "removeStory", (index, story) => {
      this.setState({
        isSharing: false,
        isRemoving: true,
        storyToRemove: story,
        storyRemoveIndex: index
      });
    });
    _defineProperty(this, "toggleRemoveDialog", () => {
      this.setState({
        isSharing: false,
        isRemoving: !this.state.isRemoving,
        storyToRemove: undefined,
        storyRemoveIndex: undefined
      });
    });
    _defineProperty(this, "resetReCaptureStatus", () => {
      this.setState({
        recaptureSuccessId: undefined
      });
    });
    _defineProperty(this, "closeShareRemoving", () => {
      this.setState({
        isRemoving: false,
        isSharing: false
      });
    });
    _defineProperty(this, "runStories", () => {
      this.closeShareRemoving();
      this.props.viewState.runStories();
    });
    _initializerDefineProperty(this, "viewState", _descriptor, this);
    _defineProperty(this, "toggleSharePanel", () => {
      this.setState({
        isRemoving: false,
        isSharing: !this.state.isSharing
      });
    });
    _defineProperty(this, "onClickCapture", () => {
      this.setState({
        editingMode: true,
        currentStory: undefined
      });
    });
    _defineProperty(this, "hideStoryBuilder", () => {
      this.props.viewState.toggleStoryBuilder();
      this.props.viewState.terria.currentViewer.notifyRepaintRequired();
      // Allow any animations to finish, then trigger a resize.
      setTimeout(function () {
        triggerResize();
      }, this.props.animationDuration || 1);
      this.props.viewState.toggleFeaturePrompt("story", false, true);
    });
    makeObservable(this);
    this.state = {
      editingMode: false,
      currentStory: undefined,
      recaptureSuccessId: undefined,
      clearRecaptureSuccessTimeout: undefined,
      showVideoGuide: false,
      isRemoving: false,
      isSharing: false,
      storyToRemove: undefined,
      storyRemoveIndex: undefined,
      storyWithOpenMenuId: undefined
    };
  }
  removeAction() {
    if (this.state.storyToRemove && this.state.storyRemoveIndex !== undefined) {
      this.props.viewState.terria.stories = this.props.viewState.terria.stories.filter(st => st.id !== this.state.storyToRemove.id);
      if (this.state.storyRemoveIndex < this.props.viewState.currentStoryId) {
        this.props.viewState.currentStoryId -= 1;
      }
    } else {
      this.removeAllStories();
    }
    this.setState({
      storyToRemove: undefined,
      storyRemoveIndex: undefined
    });
  }
  removeAllStories() {
    this.props.viewState.terria.stories = [];
  }
  onSave(_story) {
    var _this$props$viewState;
    const story = {
      title: _story.title,
      text: _story.text,
      id: _story.id ? _story.id : createGuid()
    };
    (_this$props$viewState = this.props.viewState.terria.analytics) === null || _this$props$viewState === void 0 || _this$props$viewState.logEvent(Category.story, StoryAction.saveStory, JSON.stringify(story));
    const storyIndex = (this.props.viewState.terria.stories || []).findIndex(story => story.id === _story.id);
    if (storyIndex >= 0) {
      const oldStory = this.props.viewState.terria.stories[storyIndex];
      // replace the old story, we need to replace the stories array so that
      // it is observable
      this.props.viewState.terria.stories = [...this.props.viewState.terria.stories.slice(0, storyIndex), combine(story, oldStory), ...this.props.viewState.terria.stories.slice(storyIndex + 1)];
    } else {
      this.captureStory(story);
    }
    this.setState({
      editingMode: false
    });
  }
  captureStory(story) {
    const shareData = toJS(getShareData(this.props.viewState.terria, this.props.viewState, {
      includeStories: false
    }));
    this.props.viewState.terria.stories.push(_objectSpread(_objectSpread({}, story), {}, {
      shareData
    }));
  }
  recaptureScene(story) {
    var _this$clearRecaptureS;
    const {
      t
    } = this.props;
    this.closeShareRemoving();
    (_this$clearRecaptureS = this.clearRecaptureSuccessTimeout) === null || _this$clearRecaptureS === void 0 || _this$clearRecaptureS.call(this);
    const storyIndex = (this.props.viewState.terria.stories || []).findIndex(st => st.id === story.id);
    if (storyIndex >= 0) {
      story.shareData = JSON.parse(JSON.stringify(getShareData(this.props.viewState.terria, this.props.viewState, {
        includeStories: false
      })));
      this.props.viewState.terria.stories = [...this.props.viewState.terria.stories.slice(0, storyIndex), story, ...this.props.viewState.terria.stories.slice(storyIndex + 1)];
      this.setState({
        recaptureSuccessId: story.id
      });
      const timeout = setTimeout(this.resetReCaptureStatus, 2000);
      this.clearRecaptureSuccessTimeout = () => clearTimeout(timeout);
    } else {
      throw new Error(t("story.doesNotExist"));
    }
  }
  editStory(story) {
    this.closeShareRemoving();
    this.props.viewState.storyShown = false;
    this.setState({
      editingMode: true,
      currentStory: story
    });
  }
  viewStory(index) {
    this.closeShareRemoving();
    this.props.viewState.currentStoryId = index;
    this.runStories();
  }
  onSort(sortedArray, _currentDraggingSortData, _currentDraggingIndex) {
    this.props.viewState.terria.stories = sortedArray;
  }
  get shareDataStringSize() {
    if (!this.viewState) return undefined;
    const terria = this.viewState.terria;
    const stories = terria.stories;
    const validStories = stories.filter(story => story.shareData.initSources.length > 0).length;
    return JSON.stringify(getShareData(terria, this.viewState, {
      includeStories: validStories > 0
    })).length;
  }
  componentDidMount() {
    runInAction(() => {
      this.viewState = this.props.viewState;
    });
  }
  componentDidUpdate(prevProps) {
    if (prevProps.viewState !== this.props.viewState) {
      runInAction(() => {
        this.viewState = this.props.viewState;
      });
    }
  }
  componentWillUnmount() {
    var _this$clearRecaptureS2;
    (_this$clearRecaptureS2 = this.clearRecaptureSuccessTimeout) === null || _this$clearRecaptureS2 === void 0 || _this$clearRecaptureS2.call(this);
  }
  renderIntro() {
    var _this$props$viewState2;
    const {
      t
    } = this.props;
    return /*#__PURE__*/_jsxs(Box, {
      column: true,
      children: [/*#__PURE__*/_jsx(VideoGuide, {
        viewState: this.props.viewState,
        videoLink: ((_this$props$viewState2 = this.props.viewState.terria.configParameters.storyVideo) === null || _this$props$viewState2 === void 0 ? void 0 : _this$props$viewState2.videoUrl) || "https://www.youtube-nocookie.com/embed/fbiQawV8IYY",
        background: dataStoriesImg,
        videoName: STORY_VIDEO
      }), /*#__PURE__*/_jsx(StoryButton, {
        title: t("story.gettingStartedTitle"),
        btnText: t("story.gettingStarted"),
        onClick: () => {
          this.props.viewState.setVideoGuideVisible(STORY_VIDEO);
        },
        children: /*#__PURE__*/_jsx(StyledIcon, {
          glyph: Icon.GLYPHS.play,
          light: true,
          styledWidth: "20px"
        })
      }), /*#__PURE__*/_jsx(Spacing, {
        bottom: 2
      }), /*#__PURE__*/_jsx(CaptureScene, {
        disabled: this.state.isRemoving,
        onClickCapture: this.onClickCapture
      })]
    });
  }
  renderPlayShare() {
    var _this$props$widthFrom;
    const {
      t
    } = this.props;
    return /*#__PURE__*/_jsxs(Box, {
      justifySpaceBetween: true,
      children: [/*#__PURE__*/_jsx(StoryButton, {
        fullWidth: true,
        disabled: this.state.editingMode,
        title: t("story.preview"),
        btnText: t("story.play"),
        onClick: this.runStories,
        children: /*#__PURE__*/_jsx(StyledIcon, {
          glyph: Icon.GLYPHS.playStory,
          light: true,
          styledWidth: "20px"
        })
      }), /*#__PURE__*/_jsx(Spacing, {
        right: 1
      }), /*#__PURE__*/_jsx(SharePanel, {
        storyShare: true,
        btnDisabled: this.state.editingMode,
        terria: this.props.viewState.terria,
        viewState: this.props.viewState,
        modalWidth: ((_this$props$widthFrom = this.props.widthFromMeasureElementHOC) !== null && _this$props$widthFrom !== void 0 ? _this$props$widthFrom : 100) - 22,
        onUserClick: this.toggleSharePanel
      })]
    });
  }
  openMenu(storyId) {
    this.setState({
      storyWithOpenMenuId: storyId
    });
  }
  renderStories() {
    const {
      t,
      i18n
    } = this.props;
    const stories = this.props.viewState.terria.stories || [];
    const storyName = this.state.storyToRemove ? this.state.storyToRemove.title.length ? this.state.storyToRemove.title : t("story.untitledScene") : "";
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(_StyledBox, {
        justifySpaceBetween: true,
        verticalCenter: true,
        paddedRatio: 2,
        $_css: this.props.theme.darkLighter,
        $_css2: this.props.theme.darkLighter,
        children: [/*#__PURE__*/_jsxs(TextSpan, {
          textLight: true,
          uppercase: true,
          overflowHide: true,
          overflowEllipsis: true,
          children: [t("story.badgeBarLabel"), " ", "(".concat(this.props.viewState.terria.stories.length, ")")]
        }), /*#__PURE__*/_jsxs(RawButton, {
          type: "button",
          onClick: this.toggleRemoveDialog,
          textLight: true,
          className: Styles.removeButton,
          children: [/*#__PURE__*/_jsx(Icon, {
            glyph: Icon.GLYPHS.cancel
          }), /*#__PURE__*/_jsx(TextSpan, {
            isLink: true,
            children: t("story.removeAllStories")
          })]
        })]
      }), this.props.viewState.terria.configParameters.showStorySaveInstructions && /*#__PURE__*/_jsxs(_StyledBox2, {
        verticalCenter: true,
        paddedRatio: 2,
        $_css3: this.props.theme.darkLighter,
        children: [/*#__PURE__*/_jsx(_StyledStyledIcon, {
          glyph: Icon.GLYPHS.info,
          styledWidth: "16px",
          fillColor: this.props.theme.infoColor
        }), /*#__PURE__*/_jsx(Spacing, {
          right: 1
        }), /*#__PURE__*/_jsx(TextSpan, {
          medium: true,
          color: this.props.theme.infoColor,
          children: t("story.saveInstructions")
        })]
      }), /*#__PURE__*/_jsx(Spacing, {
        bottom: 2
      }), /*#__PURE__*/_jsxs(Box, {
        column: true,
        paddedHorizontally: 2,
        flex: 1,
        styledMinHeight: "0",
        children: [this.state.isRemoving && /*#__PURE__*/_jsx(RemoveDialog, {
          theme: this.props.theme,
          text: this.state.storyToRemove ? /*#__PURE__*/_jsx(Text, {
            textLight: true,
            large: true,
            children: /*#__PURE__*/_jsxs(Trans, {
              i18nKey: "story.removeStoryDialog",
              i18n: i18n,
              children: ["Are you sure you wish to delete", /*#__PURE__*/_jsx(TextSpan, {
                textLight: true,
                large: true,
                bold: true,
                children: {
                  storyName
                }
              }), "?"]
            })
          }) : /*#__PURE__*/_jsx(Text, {
            textLight: true,
            large: true,
            children: t("story.removeAllStoriesDialog", {
              count: this.props.viewState.terria.stories.length
            })
          }),
          onConfirm: this.removeAction,
          closeDialog: this.toggleRemoveDialog
        }), /*#__PURE__*/_jsxs(_StyledBox3, {
          column: true,
          styledHeight: "100%",
          $_css4: (this.state.isRemoving || this.state.isSharing) && "opacity: 0.3",
          children: [/*#__PURE__*/_jsx(_StyledBox4, {
            column: true,
            scroll: true,
            overflowY: "auto",
            styledMaxHeight: "100%",
            ref: this.storiesWrapperRef,
            children: /*#__PURE__*/_jsx(_StyledSortable, {
              onSort: this.onSort,
              direction: "vertical",
              dynamic: true,
              children: stories.map((story, index) => /*#__PURE__*/_jsx(Story, {
                story: story,
                sortData: story,
                deleteStory: () => this.removeStory(index, story),
                recaptureStory: () => this.recaptureScene(story),
                recaptureStorySuccessful: Boolean(story.id === this.state.recaptureSuccessId),
                viewStory: () => this.viewStory(index),
                menuOpen: this.state.storyWithOpenMenuId === story.id,
                openMenu: () => this.openMenu(story.id),
                closeMenu: () => this.openMenu(undefined),
                editStory: () => this.editStory(story),
                parentRef: this.storiesWrapperRef,
                index: index
              }, "".concat(story.id)))
            })
          }), /*#__PURE__*/_jsx(Spacing, {
            bottom: 2
          }), /*#__PURE__*/_jsx(CaptureScene, {
            disabled: this.state.isRemoving,
            onClickCapture: this.onClickCapture
          }), /*#__PURE__*/_jsx(Spacing, {
            bottom: 2
          })]
        })]
      })]
    });
  }
  render() {
    var _this$props$viewState3, _this$props$viewState4;
    const {
      t
    } = this.props;
    const hasStories = this.props.viewState.terria.stories.length > 0;
    const shareDataSize = this.shareDataStringSize;
    const shareMaxRequestSize = (_this$props$viewState3 = this.props.viewState.terria.shareDataService) === null || _this$props$viewState3 === void 0 ? void 0 : _this$props$viewState3.shareMaxRequestSize;
    const shareMaxRequestSizeBytes = (_this$props$viewState4 = this.props.viewState.terria.shareDataService) === null || _this$props$viewState4 === void 0 ? void 0 : _this$props$viewState4.shareMaxRequestSizeBytes;
    // Disable the warning if map owners use custom server that does not return shareMaxRequestSize:
    const shareDataTooLong = shareDataSize && shareMaxRequestSizeBytes ? shareDataSize > shareMaxRequestSizeBytes : false;
    return /*#__PURE__*/_jsxs(Panel, {
      ref: component => this.refToMeasure = component,
      isVisible: this.props.isVisible,
      isHidden: !this.props.isVisible,
      styledWidth: "320px",
      styledMinWidth: "320px",
      backgroundColor: this.props.theme.dark,
      column: true,
      children: [/*#__PURE__*/_jsx(Box, {
        right: true,
        children: /*#__PURE__*/_jsx(_StyledRawButton, {
          onClick: this.hideStoryBuilder,
          children: /*#__PURE__*/_jsx(StyledIcon, {
            styledWidth: "16px",
            fillColor: this.props.theme.textLightDimmed,
            opacity: 0.5,
            glyph: Icon.GLYPHS.closeLight
          })
        })
      }), /*#__PURE__*/_jsxs(Box, {
        centered: true,
        paddedHorizontally: 2,
        displayInlineBlock: true,
        children: [/*#__PURE__*/_jsx(Text, {
          bold: true,
          extraExtraLarge: true,
          textLight: true,
          children: t("story.panelTitle")
        }), /*#__PURE__*/_jsx(Spacing, {
          bottom: 2
        }), /*#__PURE__*/_jsx(Text, {
          medium: true,
          color: this.props.theme.textLightDimmed,
          highlightLinks: true,
          children: "".concat(t("story.panelBody")).concat(shareMaxRequestSize ? " ".concat(t("story.panelBodyCapped", {
            shareMaxRequestSize
          })) : "")
        }), /*#__PURE__*/_jsx(Spacing, {
          bottom: 3
        }), !hasStories && this.renderIntro(), hasStories && this.renderPlayShare()]
      }), /*#__PURE__*/_jsx(Spacing, {
        bottom: 2
      }), shareDataTooLong && /*#__PURE__*/_jsx(Box, {
        paddedHorizontally: 2,
        children: /*#__PURE__*/_jsx(Text, {
          small: true,
          color: this.props.theme.textWarning,
          highlightLinks: true,
          children: t("story.storiesTooLong")
        })
      }), hasStories && this.renderStories(), this.state.editingMode && /*#__PURE__*/_jsx(StoryEditor, {
        removeStory: this.removeStory,
        exitEditingMode: () => this.setState({
          editingMode: false
        }),
        story: this.state.currentStory,
        saveStory: this.onSave,
        terria: this.props.viewState.terria
      })]
    });
  }
}, _applyDecoratedDescriptor(_class2.prototype, "removeAction", [_dec], Object.getOwnPropertyDescriptor(_class2.prototype, "removeAction"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "removeAllStories", [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, "removeAllStories"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onSave", [_dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "onSave"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "captureStory", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "captureStory"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "recaptureScene", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "recaptureScene"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "editStory", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "editStory"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "viewStory", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "viewStory"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onSort", [_dec4], Object.getOwnPropertyDescriptor(_class2.prototype, "onSort"), _class2.prototype), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "viewState", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "shareDataStringSize", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "shareDataStringSize"), _class2.prototype), _class2)) || _class);
const Panel = styled(Box).withConfig({
  displayName: "StoryBuilder__Panel",
  componentId: "sc-1uri6lw-0"
})(["transition:all 0.25s;transition-timing-function:cubic-bezier(0.4,0,0.2,1);width:320px;min-width:320px;height:100vh;", " ", ""], props => props.isVisible && "\n    visibility: visible;\n    margin-right: 0;\n  ", props => props.isHidden && "\n    visibility: hidden;\n    margin-right: -100%;\n  ");
const CaptureScene = props => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsx(StoryButton, {
    title: t("story.captureSceneTitle"),
    btnText: t("story.captureScene"),
    onClick: props.onClickCapture,
    disabled: props.disabled,
    fullWidth: true,
    children: /*#__PURE__*/_jsx(StyledIcon, {
      glyph: Icon.GLYPHS.story,
      light: true,
      styledWidth: "20px"
    })
  });
};
export const StoryButton = props => {
  const {
      btnText
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
    primary: true,
    renderIcon: props.children && (() => props.children),
    textProps: {
      large: true
    }
  }, rest), {}, {
    children: btnText ? btnText : ""
  }));
};
const RemoveDialog = props => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsxs(_StyledBox5, {
    backgroundColor: props.theme.darkLighter,
    position: "absolute",
    rounded: true,
    paddedVertically: 3,
    paddedHorizontally: 2,
    column: true,
    children: [props.text, /*#__PURE__*/_jsx(Spacing, {
      bottom: 2
    }), /*#__PURE__*/_jsxs(Box, {
      children: [/*#__PURE__*/_jsx(Button, {
        denyButton: true,
        fullWidth: true,
        textProps: {
          large: true,
          semiBold: true
        },
        onClick: props.closeDialog,
        children: t("general.cancel")
      }), /*#__PURE__*/_jsx(Spacing, {
        right: 2
      }), /*#__PURE__*/_jsx(Button, {
        primary: true,
        fullWidth: true,
        textProps: {
          large: true,
          semiBold: true
        },
        onClick: () => {
          props.onConfirm();
          props.closeDialog();
        },
        children: t("general.confirm")
      })]
    })]
  });
};
export default withViewState(withTranslation()(withTheme(measureElement(StoryBuilder))));
var _StyledBox = styled(Box).withConfig({
  displayName: "StoryBuilder___StyledBox",
  componentId: "sc-1uri6lw-1"
})(["border-top:1px solid ", ";border-bottom:1px solid ", ";"], p => p.$_css, p => p.$_css2);
var _StyledBox2 = styled(Box).withConfig({
  displayName: "StoryBuilder___StyledBox2",
  componentId: "sc-1uri6lw-2"
})(["border-bottom:1px solid ", ";"], p => p.$_css3);
var _StyledStyledIcon = styled(StyledIcon).withConfig({
  displayName: "StoryBuilder___StyledStyledIcon",
  componentId: "sc-1uri6lw-3"
})(["flex-shrink:0;"]);
var _StyledBox3 = styled(Box).withConfig({
  displayName: "StoryBuilder___StyledBox3",
  componentId: "sc-1uri6lw-4"
})(["", ""], p => p.$_css4);
var _StyledBox4 = styled(Box).withConfig({
  displayName: "StoryBuilder___StyledBox4",
  componentId: "sc-1uri6lw-5"
})(["min-height:130px;margin-right:-10px;"]);
var _StyledSortable = styled(Sortable).withConfig({
  displayName: "StoryBuilder___StyledSortable",
  componentId: "sc-1uri6lw-6"
})(["margin-right:10px;"]);
var _StyledRawButton = styled(RawButton).withConfig({
  displayName: "StoryBuilder___StyledRawButton",
  componentId: "sc-1uri6lw-7"
})(["padding:15px;"]);
var _StyledBox5 = styled(Box).withConfig({
  displayName: "StoryBuilder___StyledBox5",
  componentId: "sc-1uri6lw-8"
})(["width:calc(100% - 20px);"]);